import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from 'utils/base-query'
import { buildQueryString, CHSort } from '../candles.types'

/**
 * Целостность сбора за сутки.
 *
 * Рынки серии открываются по расписанию (5m — 288 окон в сутки, 15m — 96),
 * поэтому ожидаемое число окон известно заранее, а всё остальное — факт из
 * данных. Считает парсер раз в полчаса, API только отдаёт посчитанное.
 *
 * Сутки — в UTC, формат YYYY-MM-DD.
 */
export type PolymarketDailyStat = {
  date: string
  series: string
  /** Длина окна рынка, секунды. */
  periodSec: number

  /** Окон, которые за эти сутки успели открыться. */
  expectedMarkets: number
  /** Рынков, заведённых в справочнике. */
  knownMarkets: number
  /** Рынков, по которым есть хоть одна котировка. */
  bookMarkets: number
  /** Рынков, по которым есть хоть одна сделка. */
  tradeMarkets: number
  /** Рынков, по которым собран предторговый стакан. */
  preopenMarkets: number

  bookRows: number
  tradeRows: number
  preopenLevelRows: number
  preopenTradeRows: number

  /** Секунд суток, закрытых хотя бы одной котировкой. */
  coveredSeconds: number
  /** Секунд суток, прошедших к моменту подсчёта. */
  expectedSeconds: number

  /** Сутки ещё идут — цифры вырастут. */
  partial: boolean
}

export interface DailyStatFilter {
  series?: string
  /** Сутки в UTC, включительно. */
  startDate?: string
  endDate?: string
  limit?: number
  offset?: number
  sort?: CHSort
}

/**
 * «Вся история»: без startDate бэк отдаёт последние 14 суток, а Date в
 * ClickHouse начинается с 1970-01-01 — так запрос охватывает всё, что есть,
 * без отдельного флага в API.
 */
export const FIRST_POSSIBLE_DAY = '1970-01-01'

/** limit на бэке по умолчанию 10 — суток всегда больше, задаём явно. */
const DEFAULT_LIMIT = 90

export const apiStats = createApi({
  reducerPath: 'apiStats',
  baseQuery,
  // Прошедшие сутки уже не меняются, текущие пересчитываются раз в полчаса:
  // держать ответ в кеше дешевле, чем дёргать агрегат на каждый переход.
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getDailyStats: builder.query<PolymarketDailyStat[], DailyStatFilter>({
      query: (params) => `polymarket/stats/daily?${ buildQueryString({limit: DEFAULT_LIMIT, ...params}) }`
    })
  })
})

export const {useGetDailyStatsQuery} = apiStats
